import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Star, FileCheck, X } from 'lucide-react';
import { motion } from 'framer-motion';

const ContactButton = ({ className = '' }) => {
  const sectionVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: 'easeOut' } },
  };

  const titleVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.7, delay: 0.2 } },
  };

  const buttonVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.6, delay: 0.4 } },
  };

  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={sectionVariants}
      className={`relative z-10 max-w-4xl mx-auto px-4 text-center ${className}`}
      dir="rtl"
    >
      <div className="bg-slate-50 p-4 sm:p-6 md:p-8 rounded-2xl shadow-xl max-w-xl mx-auto border border-gray-200">
        <motion.div variants={titleVariants} className="mb-4 sm:mb-6">
          <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-2">
            צריכים עזרה משפטית?
          </h3>
          <p className="text-gray-600 text-sm sm:text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
            השאירו פרטים לקבלת ייעוץ ראשוני ללא התחייבות
          </p>
        </motion.div>

        <motion.div variants={buttonVariants} className="mt-6 sm:mt-8">
          <Link
            to="/contact"
            className="
              group relative bg-gray-800 text-white px-6 py-4 md:px-12 md:py-6 rounded-lg font-bold
              text-base sm:text-lg md:text-xl
              shadow-md hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300
              w-full md:w-auto inline-flex items-center justify-center gap-3
            "
          >
            <span>השאירו פרטים לייעוץ ראשוני</span>
            <ArrowLeft className="w-5 h-5 flex-shrink-0 group-hover:translate-x-1 transition-transform" />
          </Link>
        </motion.div>

        <div className="mt-6 sm:mt-8">
          <div className="flex flex-wrap justify-center items-center gap-4 sm:gap-6 md:gap-8">
            <div className="flex items-center gap-2 text-yellow-600">
              <Star className="w-4 h-4 fill-current text-yellow-500" />
              <span className="text-sm font-medium">ללא עלות</span>
            </div>
            <div className="w-px h-6 bg-gray-300 hidden sm:block" />
            <div className="flex items-center gap-2 text-yellow-600">
              <FileCheck className="w-4 h-4 text-yellow-500" />
              <span className="text-sm font-medium">בדיקה מהירה</span>
            </div>
            <div className="w-px h-6 bg-gray-300 hidden sm:block" />
            <div className="flex items-center gap-2 text-yellow-600">
              <X className="w-4 h-4 text-yellow-500" />
              <span className="text-sm font-medium">ללא התחייבות</span>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ContactButton;
